import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { A11yModule } from "@angular/cdk/a11y";

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [RouterOutlet, MatIconModule, A11yModule],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss'
})



export class AdminLayoutComponent {

  public isEventsRoute: boolean = false;
  public isTherapistsRoute: boolean = false;

constructor(
  private router: Router, 
  private authService: AuthService
){

const url = this.router.url;
  if (url.includes('admin/therapists')) {
    this.isEventsRoute = false;
    this.isTherapistsRoute = true;
  }
    if (url.includes('admin/events')) {
    this.isEventsRoute = true;
    this.isTherapistsRoute = false;
  }
}

logoutUser(){
  this.authService.logout().subscribe({});
  this.router.navigate(['login']);
}

returnToDashboard(){
    this.router.navigate(['/admin/events']);
}


goToEvents(){
    this.router.navigate(['/admin/events']);
    this.isEventsRoute = true;
    this.isTherapistsRoute = false;
}

goToTherapists(){
    this.router.navigate(['/admin/therapists']);
    this.isTherapistsRoute = true;
    this.isEventsRoute = false;
}

}
